interface SvgIconProps extends React.ComponentPropsWithoutRef<'img'> {
  src: string;
  alt: string;
  size?: number; // Size in Tailwind units (1-12)
  className?: string;
}

export const SvgIcon = ({
  src,
  alt,
  size = 6, // Default size of 6 (1.5rem)
  className = '',
  ...props
}: SvgIconProps) => {
  // Generate size classes based on the size prop
  const sizeClasses = `w-${size} h-${size}`;

  return (
    <img
      src={src}
      alt={alt}
      className={`shrink-0 ${sizeClasses} ${className}`}
      {...props}
    />
  );
};
